import { useDroppable } from '@dnd-kit/core';
import styles from './Droppable.module.css';
import { lsLoad } from '../../tools/Storage';
import StorageEnum from '../../enums/Storage.enum';
import type DroppableProperties from './Droppable.properties.ts';
import { useDragAndDrop } from '../../provider/drag-and-drop/DragAndDrop.hook.ts';
import { type CSSProperties, useEffect } from 'react';
import type { MarketMarketIO } from '../../generated/fresh-guard-api';

export default function DroppableView(props: DroppableProperties) {
  const market = lsLoad(StorageEnum.Market) as MarketMarketIO;
  const marketY = market?.configuration?.area?.height ?? 0;
  const marketX = market?.configuration?.area?.width ?? 0;
  const { setDroppableArea } = useDragAndDrop();
  const { setNodeRef, node } = useDroppable({
    id: props.id,
  });

  useEffect(() => {
    setDroppableArea(node.current);
  }, [node, setDroppableArea]);

  return (
    <div
      ref={setNodeRef}
      className={styles.container}
      style={
        {
          '--dndAreaX': marketX,
          '--dndAreaY': marketY,
        } as CSSProperties
      }
    >
      {props.children}
    </div>
  );
}
